/**
 * Generated by orval v7.18.0 🍺
 * Do not edit manually.
 * MobiViz
 * The MobiViz API description (multi-version)
 * OpenAPI spec version: 1.0.0
 */

/**
 * Available metric types
 */
export type Metric = (typeof Metric)[keyof typeof Metric];

export const Metric = {
  speed: "speed",
  acceleration: "acceleration",
  density: "density",
  vehicleType: "vehicleType",
  averageSpeed: "averageSpeed",
  averageAcceleration: "averageAcceleration",
} as const;
